//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: { type: String, default: '' },

    tip: {
      type: String,
      default: '',
    },

    divider: {
      type: Boolean,
      default: false,
    },
  },
}
